import { render, staticRenderFns } from "./MDstudent.vue?vue&type=template&id=3c65e360"
import script from "./MDstudent.vue?vue&type=script&lang=js"
export * from "./MDstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports